import PropTypes from 'prop-types';
import React from 'react';

import { observer } from 'mobx-react';
import CustomFormField from '../../../models/CustomFormField';
import FormField from '../../../models/FormField';
import { modelOf } from '../../../prop-types';

export const createOption = ({ disabled, value, label, content }) => {
  return {
    disabled,
    value,
    label,
    content,
  };
};

const Field = ({
  component: Component,
  field,
  onBlur,
  onChange,
  handleBlur,
  value,
  innerRef,
  validate = true,
  ...rest
}) => {
  const handleChange = (event) => {
    // Checkboxes with options (e.g. CheckboxField) keep a string[] in the model; the
    // native value is always a string and must not overwrite the array before onChange.
    if (rest.type === 'checkbox' && onChange) {
      onChange(event, field);
      return;
    }
    field.setValue(event.target.value);
    onChange && onChange(event, field);
  };

  const handleFieldBlur = (event) => {
    if (field.value && validate) {
      field.setShouldValidate(true);
    }

    handleBlur && handleBlur(event, field);
    onBlur && onBlur(event, field);
  };

  let fieldValue;
  // If an explicit value prop is provided, use it (for controlled display)
  if (value !== undefined && value !== null) {
    fieldValue = value;
  } else if (
    ['radio', 'checkbox'].indexOf(rest.type) === -1 &&
    field.value !== undefined &&
    field.value !== null
  ) {
    fieldValue = field.value;
  } else {
    fieldValue = '';
  }

  // HTML option values are strings; numeric MobX values otherwise break matching,
  // floating labels, and validation (select shows a label while field.value is "").
  if (
    rest.type === 'select' &&
    fieldValue !== '' &&
    fieldValue !== undefined &&
    fieldValue !== null
  ) {
    fieldValue = String(fieldValue);
  }

  return (
    <Component
      valid={field.valid}
      invalid={field.errors.length > 0}
      value={fieldValue}
      onChange={handleChange}
      onBlur={handleFieldBlur}
      innerRef={innerRef}
      {...rest}
    />
  );
};

Field.propTypes = {
  field: PropTypes.oneOfType([modelOf(FormField), modelOf(CustomFormField)])
    .isRequired,
  component: PropTypes.func.isRequired,
  validate: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  handleBlur: PropTypes.func,
};

export default observer(Field);
